<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Buttons'
 * Name: 'Secondary'
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3449-4090&t=ldymHtYK0zJDKBqF-4'
 */
import type { BtnSecondaryProps } from '@UI/Buttons/BtnSecondary/types/interfaces'

import { useBtnSecondary } from '@UI/Buttons/BtnSecondary/composables/use-btn-secondary.hook'
import { IconContainer } from '@UI/Other/IconContainer'

import { NuxtLink } from '#components'

defineOptions({
  name: 'BtnSecondary',
})

withDefaults(defineProps<BtnSecondaryProps>(), {
  title: '',
  color: 'black',
  disabled: false,
  selected: false,
  elementWidth: 'auto',
  to: undefined,
})

const emit = defineEmits<{
  click: []
}>()

const {
  handleClick,
} = useBtnSecondary({
  onClick: () => emit('click'),
})
</script>

<template>
  <component
    :is="to ? NuxtLink : 'button'"
    :to="to"
    :type="to ? undefined : 'button'"
    :class="['ui-btn-secondary', { selected }, color, elementWidth]"
    :title="title"
    :disabled="to ? undefined : disabled"
    @click="handleClick"
  >
    <IconContainer v-if="$slots.iconLeft">
      <slot name="iconLeft" />
    </IconContainer>
    <span class="ui-btn-secondary__text">
      {{ text }}
    </span>
    <IconContainer v-if="$slots.iconRight">
      <slot name="iconRight" />
    </IconContainer>
  </component>
</template>

<style lang="scss" scoped src="../styles/_btn-secondary.scss" />
